/**
 * @generated SignedSource<<2ddaf0b703645709b858204bf78a189b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type JobStates = "ACCEPTED" | "ASSIGNED" | "BLOCKED" | "BLOCKED_FAILED" | "BROKEN" | "CANCELED" | "CANCELING" | "EXPIRED" | "FINISHED" | "LIMITED" | "LIMITING" | "PENDING" | "PLATFORM_LIMITED" | "PLATFORM_LIMITING" | "RESERVED" | "RUNNING" | "SCHEDULED" | "SKIPPED" | "TIMED_OUT" | "TIMING_OUT" | "UNBLOCKED" | "UNBLOCKED_FAILED" | "WAITING" | "WAITING_FAILED" | "%future added value";
export type JobPrioritySearch = {
  number?: ReadonlyArray<number> | null;
};
export type JobConcurrencySearch = {
  group?: ReadonlyArray<string> | null;
};
export type JobsRefetchQuery$variables = {
  agentQueryRules?: ReadonlyArray<string> | null;
  clusterQueue?: ReadonlyArray<string> | null;
  concurrency?: JobConcurrencySearch | null;
  createdAtFrom?: any | null;
  createdAtTo?: any | null;
  isMounted: boolean;
  organizationSlug: string;
  pageSize?: number | null;
  passed?: boolean | null;
  priority?: JobPrioritySearch | null;
  states?: ReadonlyArray<JobStates> | null;
};
export type JobsRefetchQuery$data = {
  readonly organization: {
    readonly " $fragmentSpreads": FragmentRefs<"Jobs_organization">;
  } | null;
};
export type JobsRefetchQuery = {
  response: JobsRefetchQuery$data;
  variables: JobsRefetchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "agentQueryRules"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "clusterQueue"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "concurrency"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "createdAtFrom"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "createdAtTo"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isMounted"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "organizationSlug"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "pageSize"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "passed"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "priority"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "states"
},
v11 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "organizationSlug"
  }
],
v12 = {
  "kind": "Variable",
  "name": "agentQueryRules",
  "variableName": "agentQueryRules"
},
v13 = {
  "kind": "Variable",
  "name": "clusterQueue",
  "variableName": "clusterQueue"
},
v14 = {
  "kind": "Variable",
  "name": "concurrency",
  "variableName": "concurrency"
},
v15 = {
  "kind": "Variable",
  "name": "createdAtFrom",
  "variableName": "createdAtFrom"
},
v16 = {
  "kind": "Variable",
  "name": "createdAtTo",
  "variableName": "createdAtTo"
},
v17 = {
  "kind": "Variable",
  "name": "passed",
  "variableName": "passed"
},
v18 = {
  "kind": "Variable",
  "name": "priority",
  "variableName": "priority"
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "number",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "JobsRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": (v11/*: any*/),
        "concreteType": "Organization",
        "kind": "LinkedField",
        "name": "organization",
        "plural": false,
        "selections": [
          {
            "args": [
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              {
                "kind": "Variable",
                "name": "isMounted",
                "variableName": "isMounted"
              },
              {
                "kind": "Variable",
                "name": "pageSize",
                "variableName": "pageSize"
              },
              (v17/*: any*/),
              (v18/*: any*/),
              {
                "kind": "Variable",
                "name": "states",
                "variableName": "states"
              }
            ],
            "kind": "FragmentSpread",
            "name": "Jobs_organization"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v6/*: any*/),
      (v5/*: any*/),
      (v9/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v10/*: any*/),
      (v8/*: any*/),
      (v7/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Operation",
    "name": "JobsRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": (v11/*: any*/),
        "concreteType": "Organization",
        "kind": "LinkedField",
        "name": "organization",
        "plural": false,
        "selections": [
          (v19/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "slug",
            "storageKey": null
          },
          {
            "condition": "isMounted",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": [
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/),
                  (v16/*: any*/),
                  {
                    "kind": "Variable",
                    "name": "first",
                    "variableName": "pageSize"
                  },
                  (v17/*: any*/),
                  (v18/*: any*/),
                  {
                    "kind": "Variable",
                    "name": "state",
                    "variableName": "states"
                  },
                  {
                    "kind": "Literal",
                    "name": "type",
                    "value": "COMMAND"
                  }
                ],
                "concreteType": "JobConnection",
                "kind": "LinkedField",
                "name": "jobs",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "JobEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "__typename",
                            "storageKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v20/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "state",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "JobPriority",
                                "kind": "LinkedField",
                                "name": "priority",
                                "plural": false,
                                "selections": [
                                  (v21/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "agentQueryRules",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "passed",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "JobConcurrency",
                                "kind": "LinkedField",
                                "name": "concurrency",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "group",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "limit",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "createdAt",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "label",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "command",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Build",
                                "kind": "LinkedField",
                                "name": "build",
                                "plural": false,
                                "selections": [
                                  (v21/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Pipeline",
                                    "kind": "LinkedField",
                                    "name": "pipeline",
                                    "plural": false,
                                    "selections": [
                                      (v19/*: any*/),
                                      (v20/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v20/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "url",
                                "storageKey": null
                              }
                            ],
                            "type": "JobTypeCommand",
                            "abstractKey": null
                          },
                          {
                            "kind": "TypeDiscriminator",
                            "abstractKey": "__isJob"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v20/*: any*/)
                            ],
                            "type": "Node",
                            "abstractKey": "__isNode"
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasNextPage",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ]
          },
          (v20/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f0376837eb0b5ab34703000fe20477b2",
    "id": null,
    "metadata": {},
    "name": "JobsRefetchQuery",
    "operationKind": "query",
    "text": "query JobsRefetchQuery(\n  $organizationSlug: ID!\n  $isMounted: Boolean!\n  $priority: JobPrioritySearch\n  $agentQueryRules: [String!]\n  $clusterQueue: [ID!]\n  $concurrency: JobConcurrencySearch\n  $states: [JobStates!]\n  $passed: Boolean\n  $pageSize: Int\n  $createdAtFrom: DateTime\n  $createdAtTo: DateTime\n) {\n  organization(slug: $organizationSlug) {\n    ...Jobs_organization_1xuywJ\n    id\n  }\n}\n\nfragment JobLink_job on JobTypeCommand {\n  ...JobTitle_job\n  url\n}\n\nfragment JobTitle_job on JobTypeCommand {\n  label\n  command\n  build {\n    number\n    pipeline {\n      name\n      id\n    }\n    id\n  }\n}\n\nfragment Jobs_organization_1xuywJ on Organization {\n  name\n  slug\n  jobs(first: $pageSize, type: COMMAND, state: $states, priority: $priority, agentQueryRules: $agentQueryRules, clusterQueue: $clusterQueue, concurrency: $concurrency, passed: $passed, createdAtFrom: $createdAtFrom, createdAtTo: $createdAtTo) @include(if: $isMounted) {\n    edges {\n      node {\n        __typename\n        ... on JobTypeCommand {\n          id\n        }\n        ...Row_job\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n    }\n    pageInfo {\n      hasNextPage\n    }\n  }\n}\n\nfragment Row_job on Job {\n  __isJob: __typename\n  ... on JobTypeCommand {\n    id\n    state\n    priority {\n      number\n    }\n    agentQueryRules\n    passed\n    concurrency {\n      group\n      limit\n    }\n    createdAt\n  }\n  ...JobLink_job\n}\n"
  }
};
})();

(node as any).hash = "053f606cc44c995a2c85dd95ca4c56fa";

export default node;
